import React, { useRef,useState,useEffect  } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation } from 'react-router-dom';

import axios from 'axios';
import common from '../../../common';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import './primereact__saga-blue_theme.css';
import 'primereact/resources/primereact.min.css'; // 기본 스타일
import 'primeicons/primeicons.css'; // 아이콘
import 'primeflex/primeflex.css'; // 레이아웃 유틸리티
import { Tooltip } from 'primereact/tooltip';

import styles from './CandidateList.module.scss';

import Quill from 'quill'; //에디터
import 'quill/dist/quill.snow.css'; //에디터
import '../../../components/Editor/Editor.scss';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function CandidateDetail({ onList, totalMem, beforeMem, viewType, isCode, isEditIdx }) {
	const navigate = useNavigate();

	const { useAlert, useLoading, useConfirm, pToast } = common();
	const { pAlert, AlertComponent } = useAlert();
	const { pLoadingOn, pLoadingOff,LoadingComponent} = useLoading();
    const { pConfirm, ConfirmComponent } = useConfirm();
	const [ formData, setFormData ] = useState({//기본 설정
		grade: null,//회원구분 1정회원 2일반회원 3원로회원 4외국회원
		gradeTxt:'',
		depart: null,//추천분과 1 2 3 4
		departTxt:'',
		gender: null,
		genderTxt:'',
		name: '',
		birth: '',
		organization: '',//소속
		position: '',//직위
		education: '',//최종학력/학교명
		nation: '대한민국',
		call: '',
		phone: '',
		email: '',
		recoSeq: '1',//추천순위 아직 안했음
		letterRecoAchievement: Array(3).fill(''),//주요 업적 <- 안씀
		charCounts: Array(3).fill(0),//주요 업적 글자 수 <- 안씀
		achievementLongTxt: '', // <- 업적을 1개로
		data_status_idx:0,
	});

	const gradeRef = useRef(null);
	const emailRef = useRef(null);
	const departRef = useRef(null);
	const nameRef = useRef(null);
	// const birthRef = useRef(null);
	const genderRef = useRef(null);
	const organizationRef = useRef(null);
	const positionRef = useRef(null);
	const educationRef = useRef(null);
	const nationRef = useRef(null);
	// const nationOtherValueRef = useRef(null);
	const letterRecoAchievementRef = useRef(null);
	const letterRecoAchievement0Ref = useRef(null);

	const achievementLongTxtRef = useRef(null);

	//회원구분
	const Grade = [
		{ key: 'Grade1', value: '1', name: '정회원', tooltipTxt:'<b>정회원 피추천 자격 :</b> 현재 공학한림원의 일반회원인 사람' },
		{ key: 'Grade2', value: '2', name: '일반회원', tooltipTxt:'<b>일반회원 피추천 자격 :</b> 만65세 미만의 대한민국 국민, 공학·산업기술 및 관련분야에서 15년 이상 활동한 사람' },
		{ key: 'Grade4', value: '4', name: '외국회원', tooltipTxt:'<b>외국회원 피추천 자격 :</b> 대한민국 국민 이외의 사람, 공학·산업기술 및 관련분야에서 15년 이상 활동한 사람' },
	]
	const [selectedGrade, setSelectedGrade] = useState([]);
	const onChangeGrade = (e) => {
		let selected = [];
		if (e.checked) {
			selected.push(e.value);
			setFormData((prevData) => ({ ...prevData, grade: e.value.value, gradeTxt: e.value.name }));
		} else {
			selected = selected.filter(val => val !== e.value);
			setFormData((prevData) => ({ ...prevData, grade: null, gradeTxt: '' }));
		}
		setSelectedGrade(selected);
	};

	//추천분과
	const Depart = [
		{ key: 'Depart1', value: '1', name: '전기전자공학' },
		{ key: 'Depart2', value: '2', name: '기계공학' },
		{ key: 'Depart3', value: '3', name: '건설환경공학' },
		{ key: 'Depart4', value: '4', name: '화학생물공학' },
		{ key: 'Depart5', value: '5', name: '재료자원공학' },
		{ key: 'Depart6', value: '6', name: '기술경영정책' },
		{ key: 'Depart9', value: '9', name: '컴퓨팅' },
		{ key: 'Depart10', value: '10', name: '바이오메디컬' },
	]
	const [selectedDepart, setSelectedDepart] = useState([]);
	const onChangeDepart = (e) => {
		let selected = [];
		if (e.checked) {
			selected.push(e.value);
			setFormData((prevData) => ({ ...prevData, depart: e.value.value, departTxt: e.value.name }));
		} else {
			selected = selected.filter(val => val !== e.value);
			setFormData((prevData) => ({ ...prevData, depart: null,departTxt: '' }));
		}
		setSelectedDepart(selected);
	};

	//성별
	const Gender = [
		{ key: 'GenderF', value: 'F', name: '여성', label: '여' },
		{ key: 'GenderM', value: 'M', name: '남성', label: '남' },
	]
	const [selectedGender, setSelectedGender] = useState([]);
	const onChangeGender = (e) => {
		let selected = [];
		if (e.checked) {
			selected.push(e.value);
			setFormData((prevData) => ({ ...prevData, gender: e.value.value, genderTxt: e.value.name }));
		} else {
			selected = selected.filter(val => val !== e.value);
			setFormData((prevData) => ({ ...prevData, gender: null,genderTxt: '' }));
		}
		setSelectedGender(selected);
	};

	const onChangeBirth = (e) => {
		//
	};

	const onBlurBirth = (e) => {
		let value = e.target.value;
		if(value === 0 || value == ''){
			value='';
		}else{
			if (value < 1900) {
				value = 1900;
			} else if (value > 2024) {
				value = 2024;
			}
		}
		e.target.value=value;
		setFormData((prevData) => ({ ...prevData, birth: value }));
	};
	
	const [nationSelectedOption, setNationSelectedOption] = useState('대한민국');
	const [nationOtherValue, setNationOtherValue] = useState('');
	const nationOptions = [
		{ label: '대한민국', value: '대한민국' },
		{ label: '그외', value: 'other' }
	];
	const onChangeNation = (e) => {
		setNationSelectedOption(e.value);
		if (e.value !== 'other') {
			setNationOtherValue('');
		}
		setFormData((prevData) => ({ ...prevData, nation: e.value }));
	};
	const onChangeNationOther = (e) => {
		setNationOtherValue(e.target.value);
		setFormData((prevData) => ({ ...prevData, nation: e.target.value }));
	};
	
	const phoneSet = (eve = null, len = null, ref = null) => {
		if(eve && len){
			let maxLen=parseInt(len);
			let ipValue=eve.target.value;
			ipValue = ipValue.replace(/[^\d]/g, '')
			if(ref!==null && ipValue.length === maxLen){
				ref.current.focus();
			}
			if (ipValue.length > maxLen) {
				ipValue = ipValue.slice(0, maxLen);
			}
			eve.target.value=ipValue;
			return ipValue;
		}
	};

	//연락처 회사
	const [Call1, setCall1] = useState('');
	const [Call2, setCall2] = useState('');
	const [Call3, setCall3] = useState('');
	const Call2Ref = useRef(null);
	const Call3Ref = useRef(null);
	const onChangeCall1 = (e) => {
		const value = phoneSet(e,'3',Call2Ref);
		setCall1(value);
		setFormData((prevData) => ({ ...prevData, call: `${value}-${Call2}-${Call3}` }));
	};
	const onChangeCall2 = (e) => {
		const value = phoneSet(e,'4',Call3Ref);
		setCall2(value);
		setFormData((prevData) => ({ ...prevData, call: `${Call1}-${value}-${Call3}` }));
	};
	const onChangeCall3 = (e) => {
		const value = phoneSet(e,'4');
		setCall3(value);
		setFormData((prevData) => ({ ...prevData, call: `${Call1}-${Call2}-${value}` }));
	};

	//연락처 휴대폰
	const [Phone1, setPhone1] = useState('');
	const [Phone2, setPhone2] = useState('');
	const [Phone3, setPhone3] = useState('');
	const Phone2Ref = useRef(null);
	const Phone3Ref = useRef(null);
	const onChangePhone1 = (e) => {
		const value = phoneSet(e,'3',Phone2Ref);
		setPhone1(value);
		setFormData((prevData) => ({ ...prevData, phone: `${value}-${Phone2}-${Phone3}` }));
	};
	const onChangePhone2 = (e) => {
		const value = phoneSet(e,'4',Phone3Ref);
		setPhone2(value);
		setFormData((prevData) => ({ ...prevData, phone: `${Phone1}-${value}-${Phone3}` }));
	};
	const onChangePhone3 = (e) => {
		const value = phoneSet(e,'4');
		setPhone3(value);
		setFormData((prevData) => ({ ...prevData, phone: `${Phone1}-${Phone2}-${value}` }));
	};

	useEffect(() => {
		if(viewType=='edit' || viewType=='nominee'){
		}
		if(viewType=='recommendation'){
		}
		if(viewType=='edit' && isEditIdx){
			getDetail('e',isEditIdx);
		}
		if(viewType=='nominee' && isCode){
			getDetail('n',isCode);
		}
	}, [viewType, isEditIdx, isCode]);

	const [ tempFormData, setTempFormData ] = useState([]);
	const getDetail = async (type,idx) => {
        try {
            pLoadingOn();
			let postFunPath = type === 'e' ? 'in/get_detail' : 'out/get_detail';
			const postFunRequestData = type === 'e' ? { idx } : { code: idx };
			const response = await axios.post(`${API_BASE_URL}/naek_letter_reco/${postFunPath}`, postFunRequestData, { withCredentials: true });
            if (response && response.data && response.data.result === 't') {
                setDetailFormData(response.data.data);
            } else {
                console.error(response.data);
				pAlert(response.data.msg);
				if (type === 'e') {
				} else if (type === 'n') {
				}
				navigate('');
            }
        } catch (error) {
            console.error('실패:', error);
        } finally {
            setTimeout(() => {
                pLoadingOff();
            }, 300);
        }
    };

    const setDetailFormData = (data) => {

		setNationSelectedOption(data.nation === '대한민국' ? '대한민국' : 'other');
		setNationOtherValue(data.nation === '대한민국' ? '' : data.nation);

        // 등급 설정
        // const tempGrade = Grade.find(category => category.value === data.grade.toString());
		const gradeValue = isNaN(data.grade) ? (Grade.find(category => category.name === data.grade)?.value || null) : data.grade;
		const gradeText = isNaN(data.grade) ? data.grade : (Grade.find(category => category.value.toString() === data.grade.toString())?.name || '');
		const tempGrade = Grade.find(category => category.value.toString() === gradeValue.toString());
		setSelectedGrade(tempGrade ? [tempGrade] : []);

        // 부서 설정
        // const tempDepart = Depart.find(category => category.value === data.depart.toString());
		const departValue = isNaN(data.depart) ? (Depart.find(category => category.name === data.depart)?.value || null) : data.depart;
		const departText = isNaN(data.depart) ? data.depart : (Depart.find(category => category.value.toString() === data.depart.toString())?.name || '');
		const tempDepart = Depart.find(category => category.value.toString() === departValue.toString());
		setSelectedDepart(tempDepart ? [tempDepart] : []);

        // 성별 설정
        const tempGender = Gender.find(category => category.value === data.gender.toString());
		const genderText = tempGender ? tempGender.name : '';
        setSelectedGender(tempGender ? [tempGender] : []);

        // 전화번호 설정
        const callParts = data.call.split('-');
        setCall1(callParts[0] || '');
        setCall2(callParts[1] || '');
        setCall3(callParts[2] || '');

        const phoneParts = data.phone.split('-');
        setPhone1(phoneParts[0] || '');
        setPhone2(phoneParts[1] || '');
        setPhone3(phoneParts[2] || '');
		
		// 업적 여러개 버전
		const achievements = Array.isArray(data.letterRecoAchievement) ? data.letterRecoAchievement : Array(3).fill('');

		// 업적 1개 버전으로(기 작성된 예비추에서 2개 이상이라면 줄바꿈으로 1개로 만들기)
		const achievement = Array.isArray(data.letterRecoAchievement)
			? (
				data.letterRecoAchievement.length > 1
					? data.letterRecoAchievement.filter(Boolean).join('\r\n')
					: data.letterRecoAchievement[0] || ''
				)
			: (typeof data.letterRecoAchievement === 'string' ? data.letterRecoAchievement : '');


		const putFormData = {
			// grade: data.grade || null,
			grade: gradeValue || null,
			gradeTxt: gradeText || null,
			// depart: data.depart || null,
			depart: departValue || null,
			departTxt: departText || null,
			name: data.name || '',
			birth: data.birth || '',
			gender: data.gender || '',
			genderTxt: genderText || null,
			organization: data.organization || '',
			position: data.position || '',
			education: data.education || '',
			nation: data.nation || '',
			call: data.call || '',
			phone: data.phone || '',
			email: data.email || '',
			recoSeq: data.recoSeq || '0',
			letterRecoAchievement: achievements, // <- 업적 여러개 버전 안씀
			charCounts: achievements.map(achievement => achievement.length), // <- 업적 여러개 버전 안씀
			achievementLongTxt: achievement, // <- 업적 1개 버전 씀
			data_status_idx: data.data_status_idx || '0',
		};

		setFormData(putFormData);
		setTempFormData(putFormData);
    };
	
	const [isSubmitButton, setIsSubmitButton] = useState(false);
    const candidateSubmit = async (e) => {
        // e.preventDefault();
        if (!formData.grade) {
            pAlert('회원구분을 선택해 주세요.');
			gradeRef.current.focus();
            return;
        }
        if (!formData.depart) {
            pAlert('추천분과를 선택해 주세요.');
			departRef.current.focus();
            return;
        }
        if (!formData.name) {
            pAlert('성명을 입력해 주세요.');
			nameRef.current.focus();
            return;
        }
        if (!formData.organization) {
            pAlert('소속을 입력해 주세요.');
			organizationRef.current.focus();
            return;
        }
        if (!formData.position) {
            pAlert('직위를 입력해 주세요.');
			positionRef.current.focus();
            return;
        }
        if (!formData.nation) {
            pAlert('국적을 선택해 주세요.');
			nationRef.current.focus();
            return;
        }
        if (!formData.phone) {
            pAlert('연락처 휴대폰을 입력해 주세요.');
			Phone2Ref.current.focus();
            return;
        }
        if (!formData.email) {
            pAlert('이메일을 입력해 주세요.');
			emailRef.current.focus();
            return;
        }
        if (!formData.achievementLongTxt) {
            pAlert('주요 업적을 입력해 주세요.');
			achievementLongTxtRef.current.focus();
            return;
        }
		if(countNonWhitespace(formData.achievementLongTxt) > achievement_maxLen){
			return pAlert(`${fieldNames['achievementLongTxt']} 의 글자수가 초과되었습니다.<br />(${countNonWhitespace(formData.achievementLongTxt).toLocaleString()} / ${achievement_maxLen.toLocaleString()})`);
		}
		

		pConfirm(
            '예비추천서 제출 확인',
            <>
                <div>해당 예비추천서를 제출 하시겠습니까?</div>
            </>,
            '400px',
            'auto',
            async () => {
                const postData = {};
                if (formData.grade && formData.grade) postData.grade = formData.grade;
                if (formData.depart && formData.depart) postData.depart = formData.depart;
                if (formData.name) postData.name = formData.name;
                if (formData.birth) postData.birth = formData.birth;
                if (formData.gender && formData.gender) postData.gender = formData.gender;
                if (formData.organization) postData.organization = formData.organization;
                if (formData.position) postData.position = formData.position;
                if (formData.education) postData.education = formData.education;
                if (formData.nation) postData.nation = formData.nation;
                if (formData.call) postData.call = formData.call;
                if (formData.phone) postData.phone = formData.phone;
                if (formData.email) postData.email = formData.email;
                if (formData.recoSeq && formData.recoSeq) postData.recoSeq = formData.recoSeq;

                if (formData.letterRecoAchievement) postData.letterRecoAchievement = formData.letterRecoAchievement; // <- 업적 여러개 버전인데 컨트롤러 안바꾸려고 여기에 0번째에 싣어나름
                // if (formData.achievementLongTxt) postData.achievementLongTxt = formData.achievementLongTxt; // <- 업적 1개 버전인데 이건 컨트롤러 가봤자 무용지물
                try {
                    pLoadingOn();
                    const response = await axios.post(`${API_BASE_URL}/naek_letter_reco/in/data_insert`, postData, { withCredentials: true });
                    if (response.data.result === 't') {
						setIsSubmitButton(true);
                        pAlert('예비추천서 제출이 완료되었습니다!');
                    } else {
                        pAlert(response.data.msg);
                    }
                } catch (error) {
                    console.error('제출 실패:', error);
                } finally {
					setTimeout(() => {
						pLoadingOff();
					}, 500);
                }
            }
        );
    };
	
    const fieldNames = {
        grade: '회원구분',
        gradeTxt: '회원구분',
        depart: '추천분과',
        departTxt: '추천분과',
        name: '이름',
        birth: '생년',
        gender: '성별',
        genderTxt: '성별',
        organization: '소속',
        position: '직위',
        education: '최종학력/학교명',
        nation: '국적',
        call: '연락처(회사)',
        phone: '연락처(휴대폰)',
        email: '이메일',
        recoSeq: '추천 순위',
        letterRecoAchievement: '업적',
        achievementLongTxt: '업적'
    };
	
    const countNonWhitespace = (str) => {
		if (str === null || str === '' || str === undefined) {
			return 0;
		}
        // return str.replace(/\s/g, '').length;
		return str.length;
    };
	const achievement_maxLen=1000;
	const [testa, setTesta] = useState('');
	return (
		<>
		<AlertComponent />
		<LoadingComponent />
		<ConfirmComponent />
		<div className='components_wrap'>
			{isCode && viewType=='nominee' &&
				<>
				<div className={`${styles.info_box}`}>
				</div>
				</>
			}

			{isEditIdx && viewType=='edit' &&
				<>
				<div className={`${styles.info_box}`}>
				</div>
				</>
			}

			{viewType=='recommendation' &&
				<>
				<div className={`${styles.info_box3}`}>
					<span className='f_small'>* 표시는 필수 입력 사항입니다.</span>
				</div>
				</>
			}


			<Tooltip
			target=".grade_tooltip"
			className='el_grade_tooltip'
			autoHide={false}
			at='left bottom'
			my='left top+10'
			>
				<div dangerouslySetInnerHTML={{ __html: testa }} />
			</Tooltip>

			<div className={styles.recommend_candidate_wrap}>

				<div className=''>
					<div className='p_i'>
						<span className='p_i_b_tit f_bigger f_bold ' >1. 추천 부문</span>
					</div>
				</div>
				<div className='p_i_sec'>
					<div className='p_i'>
						<span className='p_i_b_tit f_big f_bold required' >회원구분</span>
						<div className='p_i_con_box'>
							{Grade.map((category) => {
								return (
									<div key={category.key} className='p_i_c_3' onMouseOver={() => setTesta(category.tooltipTxt)}>
										<div className='grade_tooltip' style={{display:'inline-block'}}>
											<Checkbox
												inputId={category.key}
												name="Grade"
												value={category}
												onChange={onChangeGrade}
												checked={selectedGrade.some((item) => item.value === category.value)}
												ref={gradeRef}
											/>
											<label htmlFor={category.key} className="ml-2 f_normal">{category.name}</label>
										</div>
									</div>
								);
							})}
						</div>
					</div>
				</div>
				<div className='p_i_sec'>
					<div className='p_i'>
						<span className='p_i_b_tit f_big f_bold required'>추천분과</span>
						{/* <span className='p_i_b_tit_mini f_normal '> 1개 분과만 선택</span> */}
						<div className='p_i_con_box'>
							{Depart.map((category) => {
								return (
									<div key={category.key} className='p_i_c_3'>
										<Checkbox
											inputId={category.key}
											name="Depart"
											value={category}
											onChange={onChangeDepart}
											checked={selectedDepart.some((item) => item.value === category.value)}
											ref={departRef}
										/>
										<label htmlFor={category.key} className="ml-2 f_normal">{category.name}</label>
									</div>
								);
							})}
						</div>
					</div>
				</div>
				<div className='p_i_sec'>
					<div className=''>
						<span className='p_i_b_tit f_bigger f_bold'>2. 인적사항</span>
						{/* <span className='p_i_b_tit_mini f_normal '>(업적 요약 자료)</span> */}
					</div>
					<div className='p_i_row'>
						<div className={`p_i p_i_3 ${styles.p_i_name}`}>
							<span className='p_i_tit f_small required'>성명</span>
							<div className='p_i_con_box'>
								<InputText
									className='p_ip'
									placeholder='홍길동'
									// keyfilter="alpha"
									keyfilter={/^[A-Za-z가-힣\s]*$/}
									value={formData.name}
									onChange={(e) => setFormData((prevData) => ({ ...prevData, name: e.target.value }))}
									ref={nameRef}
								/>
							</div>
						</div>
						<div className={`p_i p_i_3 ${styles.p_i_birth}`}>
							<span className='p_i_tit f_small '>생년</span>
							<div className='p_i_con_box'>
								<InputNumber
									// min={1900}
									max={2024}
									useGrouping={false}
									inputClassName='p_ip'
									placeholder='1970' 
									// value={formData.birth}
									value={formData.birth === '' || formData.birth === 0 || formData.birth === '0' ? null : formData.birth}
									onChange={onChangeBirth}
									onBlur={onBlurBirth} 
									// ref={birthRef}
								/>
							</div>
						</div>
					</div>
					<div className='p_i_row'>
						<div className='p_i p_i_3'>
							<span className='p_i_tit f_small required'>소속</span>
							<div className='p_i_con_box'>
								<input type="text" className='p_ip'
									value={formData.organization}
									onChange={(e) => setFormData((prevData) => ({ ...prevData, organization: e.target.value }))}
									ref={organizationRef}
								/>
							</div>
						</div>
						<div className='p_i p_i_3'>
							<span className='p_i_tit f_small required'>직위</span>
							<div className='p_i_con_box'>
								<input type="text" className='p_ip'
									value={formData.position}
									onChange={(e) => setFormData((prevData) => ({ ...prevData, position: e.target.value }))}
									ref={positionRef}
								/>
							</div>
						</div>
					</div>
					<div className='p_i'>
						<span className='p_i_tit f_small required'>국적</span>
						<div className='p_i_con_box'>
							<Dropdown
								options={nationOptions}
								value={nationSelectedOption}
								onChange={onChangeNation}
								placeholder="Select an option"
								className={styles.dropdown_nation}
								ref={nationRef}
							/>
							{nationSelectedOption === 'other' && (
								<InputText
									value={nationOtherValue}
									onChange={onChangeNationOther}
									placeholder="국적을 입력해주세요."
									className={`p_ip ${styles.nation_other_ip}`}
								/>
							)}
						</div>
					</div>
				</div>

				<div className='p_i_sec'>
					<div className=''>
						<span className='p_i_b_tit f_big f_bold'>연락처</span>
					</div>
					<div className='p_i_row'>
						<div className='p_i p_i_3 p_i_m_full'>
							<span className='p_i_tit f_small required'>휴대폰</span>
							<div className='p_i_con_box p_i_c_b_phone'>
								<InputText
									keyfilter='num'
									className='p_ip'
									maxLength={3}
									value={Phone1}
									onInput={onChangePhone1}
								/>
								<span>-</span>
								<InputText
									keyfilter='num'
									className='p_ip'
									maxLength={4}
									value={Phone2}
									onInput={onChangePhone2}
									ref={Phone2Ref}
								/>
								<span>-</span>
								<InputText
									keyfilter='num'
									className='p_ip'
									maxLength={4}
									value={Phone3}
									onInput={onChangePhone3}
									ref={Phone3Ref}
								/>
							</div>
						</div>
						<div className='p_i p_i_3 p_i_m_full'>
							<span className='p_i_tit f_small '>회사</span>
							<div className='p_i_con_box p_i_c_b_phone'>
								<InputText
									keyfilter='num'
									className='p_ip'
									maxLength={3}
									value={Call1}
									onInput={onChangeCall1}
								/>
								<span>-</span>
								<InputText
									keyfilter='num'
									className='p_ip'
									maxLength={4}
									value={Call2}
									onInput={onChangeCall2}
									ref={Call2Ref}
								/>
								<span>-</span>
								<InputText
									keyfilter='num'
									className='p_ip'
									maxLength={4}
									value={Call3}
									onInput={onChangeCall3}
									ref={Call3Ref}
								/>
							</div>
						</div>
						<div className='p_i p_i_3'>
							<span className='p_i_tit f_small required'>E-mail</span>
							<div className='p_i_con_box'>
								<InputText
									keyfilter='email'
									className='p_ip'
									value={formData.email}
									onChange={(e) => setFormData((prevData) => ({ ...prevData, email: e.target.value }))}
									ref={emailRef}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className='p_i_sec'>
					<div className=''>
						<span className='p_i_b_tit f_bigger f_bold required'>3. 주요 업적</span>
						<span className='p_i_b_tit_mini f_normal '>(간략하게 최소 1건 작성)</span>
						
					</div>
					<div className='p_i'>
						<div className='p_i_con_box'>
							<textarea
								className="p_txtarea"
								value={formData.achievementLongTxt || ''}
								onChange={(e) => setFormData((prevData) => ({
									...prevData,
									achievementLongTxt: e.target.value,
									letterRecoAchievement: [e.target.value]
								}))}
								ref={achievementLongTxtRef}
							>
							</textarea>
						</div>
					</div>
				</div>
			</div>
			<div className={styles.recommend_candidate_foot_wrap}>
				{viewType=='recommendation' &&
					<>
					<div className='p_i_sec'>
						<div className='p_i'>
							<div className='p_i_con_box'>
								<span className='f_normal'>위 후보자를 한국공학한림원 회원으로 예비 추천합니다.</span>
							</div>
						</div>
						<div className='p_i'>
							<div className='p_i_con_box'>
								<span className='f_normal'>한국공학한림원 회원심사를 위한 예비추천서를 작성함에 있어 사실 그대로 거짓 없이 작성하며, 허위 사실이나 결격사유가 있을 경우, 후보자 추천을 취하할 것을 서약합니다.</span>
							</div>
						</div>
					</div>
					<div className='p_i_sec'>
						<div className='p_i'>
							<div className='p_i_con_box center'>
								<button onClick={onList} className='p_btn p_btn_normal'>뒤로가기</button>
								{!isSubmitButton && (
									<button onClick={candidateSubmit} className='p_btn p_btn_normal p_btn_blue mgl10'>제출</button>
								)}
							</div>
						</div>
					</div>
					</>
				}
				{viewType=='edit' &&
					<>
					<div className='p_i_sec'>
					</div>
					<div className='p_i_sec'>
						<div className='p_i'>
							<div className='p_i_con_box center'>
								<button onClick={onList} className='p_btn p_btn_normal'>뒤로가기</button>
							</div>
						</div>
					</div>
					</>
				}
				{viewType=='nominee' && isCode &&
					<>
					{(formData.data_status_idx === 230101 || formData.data_status_idx === 330101) ? (
						<>
							{/* 230101-정회원이 등록 */}
							{/* 230201-피추천인이 승인 */}
							{/* 330101-관리자에 의한 기본추천서 등록 */}
							{/* 330201-관리자가 기본추천서 승인 */}
							<div className='p_i_sec'>
								<div className='p_i'>
									<div className='p_i_con_box'>
										<span className='f_normal before_required'>뒤로가기나 화면을 종료하면 저장되지 않습니다. 임시저장버튼을 눌러 데이터를 저장해주세요.</span>
									</div>
								</div>
								<div className='p_i'>
									<div className='p_i_con_box'>
										<span className='f_normal before_required'>승인버튼을 누르면 관리자 심사 후 지명추천서 입력 단계로 진행됩니다.</span>
									</div>
								</div>
								<div className='p_i'>
									<div className='p_i_con_box'>
										<span className='f_normal before_required'>한국공학한림원 신입회원 심사를 위한 기본추천서를 작성함에 있어 있는 사실을 그대로 거짓 없이 작성하며, 차후 허위 사실이나 결격사유가 있을 경우, 후보자 추천을 취하할 것을 서약합니다.</span>
									</div>
								</div>
							</div>
							<div className='p_i_sec'>
								<div className='p_i'>
									<div className='p_i_con_box center'>
										{/* <button onClick={nomineeEdit} className='p_btn p_btn_normal '>수정</button> */}
										{/* <button onClick={nomineeSubmit} className='p_btn p_btn_normal p_btn_blue mgl10'>승인</button> */}
									</div>
								</div>
							</div>

						</>
					) : (
						<div className='p_i_sec'>
						</div>
					)}

					</>
				}
			</div>
		</div>
		</>
	);
}


































function RefDetail({ onList, isEditIdx }) {
	
	const quillCareerRef = useRef(null);
	const editorCareerRef = useRef(null);
	const [countCareer, setCountCareer] = useState(0);
	
	const navigate = useNavigate();

	const { useAlert, useLoading, useConfirm, pToast } = common();
	const { pAlert, AlertComponent } = useAlert();
	const { pLoadingOn, pLoadingOff,LoadingComponent} = useLoading();
    const { pConfirm, ConfirmComponent } = useConfirm();
	const [ formData, setFormData ] = useState({//기본 설정
		code:'',
		name: '',
		organization: '',//소속
		dept: '',//부서
		position: '',//직위
		refReason:'',
		data_status_idx:0,
	});

	useEffect(() => {
		if(isEditIdx){
			getDetail('',isEditIdx);
		}
	}, []);

	const getDetail = async (type,idx) => {
        try {
            pLoadingOn();
			const response = await axios.post(`${API_BASE_URL}/naek_letter_ref/in/get_detail`, { idx: idx }, { withCredentials: true });
            if (response && response.data && response.data.result === 't') {
                setDetailFormData(response.data.data);
				if(type==='go_submit'){
					nomineeEdit('submit')
				}
            } else {
                console.error(response.data);
				pAlert(response.data.msg);
				navigate('');
            }
        } catch (error) {
            console.error('실패:', error);
        } finally {
            setTimeout(() => {
                pLoadingOff();
            }, 300);
        }
    };

	const [ GetDeOriFormData, setGetDeOriFormData ] = useState([]);
    const setDetailFormData = (data) => {
		setFormData(data);
		setGetDeOriFormData(data);

		if (quillCareerRef.current) {
			const quillCareer = quillCareerRef.current;
			const editorCareer = quillCareer.root;
			editorCareer.innerHTML = data.refReason || '';
		}
    };

	const fieldNames = {
		refReason:'추천 사유',
	};
	const updateFieldValues = (changedData, originalData, fieldNames) => {
		const diffData = {};
		let changes = [];

		Object.keys(changedData).forEach(key => {
			if (fieldNames[key]) {
				if (JSON.stringify(changedData[key]) !== JSON.stringify(originalData[key])) {
					diffData[key] = changedData[key];
					if (changedData[key] === '' || changedData[key] === null) {
						changes.push([fieldNames[key], originalData[key], '내용 삭제']);
					} else {
						changes.push([fieldNames[key], originalData[key] || '없음', changedData[key]]);
					}
				}
			}
		});
		return { diffData, changes };
	};

	const [UpdatedReady, setUpdatedReady] = useState(false);
	const [UpdatedType, setUpdatedType] = useState('');
	
	useEffect(() => {
		if (UpdatedReady) {
			const submitData = async () => {
				try {
					// if(UpdatedType==='save'){
						const { diffData, changes } = updateFieldValues(formData, GetDeOriFormData, fieldNames);
						if(Object.keys(diffData).length>0){
							const confirmTitle = UpdatedType === 'submit' ? '제출' : '저장';
							const confirmMessage = UpdatedType === 'submit'
							? '추천서를 제출하기 전 아래 내용으로 추천서 내용이 저장됩니다.'
							: '아래 내용으로 저장 하시겠습니까?';
							pConfirm(
								confirmTitle,
								<>
									<div>{confirmMessage}</div>
									<div className='naek_table nomi_changed_confirm_table'>
										<div className='p-datatable'>
											<table>
												<thead>
													<tr>
														<th></th>
														<th>변경 전</th>
														<th>변경 후</th>
													</tr>
												</thead>
												<tbody>
													{changes
													.sort((a, b) => a[0].localeCompare(b[0])) // 필드 이름 기준으로 오름차순 정렬
													.map(([field, before, after], index) => (
														<tr key={index}>
															<td>{field}</td>
															<td dangerouslySetInnerHTML={{ __html: before }}></td>
															<td dangerouslySetInnerHTML={{ __html: after }}></td>
														</tr>
													))}
												</tbody>
											</table>
										</div>
									</div>
									<div>저장이 완료되면 데이터를 되돌릴 수 없습니다!</div>
								</>,
								'auto',
								'auto',
								async () => {
									try {
										pLoadingOn();
					
										const realFormData = new FormData();
										realFormData.append('targetIdx', formData.idx);
										realFormData.append('type', 'save');

										Object.entries(diffData).forEach(([key, value]) => {
											if (key !== 'fileUpload') {
												realFormData.append(key, value);
											}
										});
										const response = await axios.post(`${API_BASE_URL}/naek_letter_ref/in/submit_ref`, realFormData, {
											withCredentials: true,
											headers: {
												'Content-Type': 'multipart/form-data'
											}
										});
										if (response.data.result === 't') {
											if(UpdatedType==='save'){
												getDetail('', formData.idx);
											}
											if(UpdatedType==='submit'){
												getDetail('go_submit', formData.idx);
											}
										}
										pAlert(response.data.msg);
									} catch (error) {
										console.error('등록 실패:', error);
									} finally {
										pLoadingOff();
									}
								}
							);
						}else{
							if(UpdatedType==='save'){
								pAlert('변경된 내용이 없습니다!');
							}
							if(UpdatedType==='submit'){
								const { diffData, changes } = updateFieldValues(formData, GetDeOriFormData, fieldNames);
								pConfirm(
									'추천서 제출 확인',
									<>
										<div className='nomi_f_top_info'>
											<span>추천서 제출이 완료되면 더 이상 수정하실 수 없습니다.</span>
											<span>추천서를 제출하시겠습니까?</span>
										</div>
										<div className='mgt20'></div>
									</>,
									'auto',
									'auto',
									async () => {
										try {
											pLoadingOn();
						
											const realFormData = new FormData();
											realFormData.append('targetIdx', formData.idx);
											realFormData.append('type', UpdatedType);

											Object.entries(diffData).forEach(([key, value]) => {
												if (key !== 'fileUpload') {
													realFormData.append(key, value);
												}
											});
											const response = await axios.post(`${API_BASE_URL}/naek_letter_ref/in/submit_ref`, realFormData, {
												withCredentials: true,
												headers: {
													'Content-Type': 'multipart/form-data'
												}
											});
											if (response.data.result === 't') {
												getDetail('n',formData.idx);
											}
											pAlert(response.data.msg);
										} catch (error) {
											console.error('등록 실패:', error);
										} finally {
											pLoadingOff();
										}
									},
									'제출',//확인버튼 텍스트
									'',//취소버튼 텍스트
									'',//제목 클래스명
									'nomi_final_agree_con',//콘텐츠 클래스명
									'nomi_final_agree_btn_box',//모달 컨텐츠 클래스명
								);
							}
						}
					// }

				} catch (error) {
					// console.error('Error submitting data:', error);
				}
			};
			submitData();
			setUpdatedReady(false); // 상태가 업데이트 되었음을 초기화
		}
	}, [formData, UpdatedReady]);

	const nomineeEdit = async (action) => {
		if(countCareer > maxLenCareer){
			return pAlert(`${fieldNames['refReason']} 의 글자수가 초과되었습니다! (${countCareer} / ${maxLenCareer})`);
		}
		let CareerContent = quillCareerRef.current.root.innerHTML; //
		if (!CareerContent || CareerContent.trim() === '<p><br></p>') {
			CareerContent=null;
		}
		if (action ==='submit'){
			if (!CareerContent || CareerContent.trim() === '<p><br></p>') {
				return pAlert('추천 사유 입력해 주세요.');
			}
		}
		setFormData((prevData) => ({
			...prevData,
			refReason: CareerContent
		}))
		setUpdatedReady(true);
		setUpdatedType(action);
	};

	const handleDrop = async (event) => {
		event.preventDefault();
		event.stopPropagation();
	};
	const handleDragOver = (event) => {
		event.preventDefault();
		event.stopPropagation();
	};
	const maxLenCareer = 1000;
	const quillOptions = {
		theme: 'snow',
		modules: {
			toolbar: {
			container: [
				['bold', 'underline', { color: [] }],
			],
			},
		},
		formats: ['bold', 'underline', 'color'],
	};
	useEffect(() => {
		if (editorCareerRef.current) {
			const quill = new Quill(editorCareerRef.current, quillOptions);
			quillCareerRef.current = quill;
			quill.on('text-change', function (delta, oldDelta, source) {
				const plainText = quill.getText(); // 개행 포함 전체 문자열
				setCountCareer(plainText.length - 1);
			});

			quill.root.addEventListener('drop', handleDrop, true);
			quill.root.addEventListener('dragover', handleDragOver, true);

			const editorContainer = editorCareerRef.current;
			editorContainer.addEventListener('drop', handleDrop);
			editorContainer.addEventListener('dragover', handleDragOver);

			setTimeout(() => {
				const editorRoot = quill.root;
				const emptyTags = editorRoot.querySelectorAll('div:empty, p:empty');
				emptyTags.forEach(tag => {
					tag.remove();
				});
				const emptyLineTags = editorRoot.querySelectorAll('p');
				emptyLineTags.forEach(tag => {
					if (tag.innerHTML.trim() === '' || tag.innerHTML === '<br>') {
						tag.remove();
					}
				});
			}, 500);
			return () => {
				quill.root.removeEventListener('drop', handleDrop, true);
				quill.root.removeEventListener('dragover', handleDragOver, true);
				editorContainer.removeEventListener('drop', handleDrop);
				editorContainer.removeEventListener('dragover', handleDragOver);
			};
		}
	}, []);




	const [getConResult, setGetConResult] = useState('');
	const [getConResultBtn, setGetConResultBtn] = useState('');
	const getContents = async (action) => {
		try {
			pLoadingOn();
			setGetConResultBtn(action)
			const response = await axios.post(`${API_BASE_URL}/naek_letter_ref/in/get_contents`, {idx: formData.idx, action: action}, { withCredentials: true });
			if (response.data.result === 't') {
				setGetConResult(response.data.data)
			}
		} catch (error) {
			console.error('실패:', error);
		} finally {
			pLoadingOff();
		}
	};

	const openNomi = async () => {
		try {
			pLoadingOn();
			const response = await axios.post(`${API_BASE_URL}/naek_letter_nomi/out/access_nomi`, { code: formData.code }, { withCredentials: true });
			if (response && response.data && response.data.result === 't') {
				window.open(`/nomi?view=edit&code=${response.data.data}`, '_blank', 'noopener,noreferrer');
			} else {
				console.error(response.data);
				pAlert(response.data.msg);
			}
		} catch (error) {
			console.error('실패:', error);
		} finally {
			pLoadingOff();
		}
	};
	

	return (
		<>
		<AlertComponent />
		<LoadingComponent />
		<ConfirmComponent />
		<div className='components_wrap'>
			{ formData.status_view=== 1 &&
				<>
				<div className={`${styles.info_box}`}>
					{ formData.status_view === 1 &&
						<>
						<span className='f_normal before_required'>아래 추천서 양식을 작성하시고 제출 버튼을 눌러주세요.</span>
						<div className="pd5"></div>
						<span className='f_normal before_required'>뒤로가기나 화면을 종료하면 저장되지 않습니다. 임시저장버튼을 눌러 데이터를 저장해주세요.</span>
						<div className="pd5"></div>
						</>
					}
					{ formData.status_view === 2 &&
						<>
						<span className='f_normal before_required'>제출이 완료된 추천서 입니다.</span>
						<div className="pd5"></div>
						</>
					}
				</div>
				</>
			}

			<div className={styles.recommend_candidate_wrap}>

				<div className='p_i_sec'>
					<div className=''>
						<span className='p_i_b_tit f_bigger f_bold'>1. 후보자 인적사항</span>
					</div>
					<div className='p_i_row'>
						<div className={`p_i  ${styles.p_i_name}`}>
							<span className='p_i_tit f_small '>성명</span>
							<span className='p_i_con'>{formData.name || ''}</span>
						</div>
					</div>
					<div className='p_i_row'>
						<div className={`p_i  ${styles.p_i_name}`}>
							<span className='p_i_tit f_small '>현직</span>
							<span className='p_i_con'>{formData.organization || ''} {formData.dept ? ` / ${formData.dept}` : ''} / {formData.position || ''}</span>
						</div>
					</div>
				</div>

				<div className='p_i_sec'>
					<div>
						<span className='p_i_b_tit f_bigger f_bold'>2. 추천 사유</span>
					</div>
					<div className='p_i'>
						<span className='f_normal '>후보자의 주요 업적을 중심으로 설명하시기 바랍니다. (공백 포함 1,000자 이내)</span>
					</div>
					<div className='p_i'>
						<div className='nomi_editor_container nomi_naekCareer_editor_container' ref={editorCareerRef}></div>
						<span className="char_count">{countCareer.toLocaleString()}/{maxLenCareer.toLocaleString()}</span>
						{countCareer > maxLenCareer && (
							<span className="char_count_warning">{maxLenCareer.toLocaleString()}자를 초과하였습니다.</span>
						)}
					</div>



					{ formData.status_view=== 1 &&
						<>
						<div className='p_i'>
							<button onClick={() => getContents('reco1')}
								className={`p_btn ${getConResultBtn === 'reco1' ? 'p_btn_blue' : ''}`}
							>예비추천서 "주요 업적" 확인하기.</button>
							<button onClick={() => getContents('nomi1')}
								className={`p_btn mgl10 ${getConResultBtn === 'nomi1' ? 'p_btn_blue' : ''}`}
							>지원서 "업적" 확인하기.</button>
							<button onClick={() => getContents('nomi2')}
								className={`p_btn mgl10 ${getConResultBtn === 'nomi2' ? 'p_btn_blue' : ''}`}
							>지원서 "공학한림원 활동 내역 및 계획" 확인하기.</button>
							<button onClick={() => openNomi()}
								className={`p_btn mgl10`}
							>{formData.name || ''}님 지원서 새창열기.</button>
						</div>
						{ getConResult !=='' &&
							<div
								className={styles.get_contents_result_box}
								dangerouslySetInnerHTML={{ __html: getConResult }}
							/>
						}
						
						</>
					}
				</div>
			</div>
			
			<div className={styles.recommend_candidate_foot_wrap}>
				<div className='p_i_sec'>
					<div className='p_i'>
						<div className='p_i_con_box'>
							<span className='f_normal'>위 후보자를 한국공학한림원 회원으로 추천합니다.</span>
						</div>
					</div>
				</div>
				<div className='p_i_sec'>
					<div className='p_i'>
						<div className='p_i_con_box center'>
							<button onClick={onList} className='p_btn p_btn_normal mgr10'>뒤로가기</button>
							{ formData.status_view=== 1 &&
								<>
								<button onClick={() => nomineeEdit('save')} className='p_btn p_btn_normal'>임시저장</button>
								<button onClick={() => nomineeEdit('submit')} className='p_btn p_btn_normal p_btn_blue mgl10'>제출</button>
								</>
							}
						</div>
					</div>
				</div>
			</div>
		</div>
		</>
	);
}





































































function CandidateList({ onRecommendation, onEdit, onEditRef, listType }) {
    const location = useLocation();
	const { useAlert, useLoading } = common();
	const { pAlert, AlertComponent } = useAlert();
	const { pLoadingOn, pLoadingOff,LoadingComponent} = useLoading();

	const [getData, setGetData] = useState([]);//
	const [getDataLen, setGetDataLen] = useState(0);//
	const [getData2, setGetData2] = useState(0);//
	const [getData3, setGetData3] = useState(0);//
	const [getDataRefLen, setGetDataRefLen] = useState(0);//
	
	const [activeTab, setActiveTab] = useState('reco'); // reco, ref

    useEffect(() => {
		if(listType==='listref' && activeTab !=='ref'){
			setActiveTab('ref');
		}
    }, [listType]);
	
    useEffect(() => {
		const currentQueryStr = location.search;
		if (currentQueryStr === '?ptype=ref'){
			setActiveTab('ref');
			listType='listref';
		}
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                pLoadingOn();
                const response = await axios.post(`${API_BASE_URL}/naek_letter_reco/in/get_table`,{  }, { withCredentials: true });
                if (response.data && response.data.result === 't') {
					setGetData2(response.data.data2);
					if (response.data.data2===1){
						const tmpData = response.data.data;
						setGetDataLen(tmpData.length);
						setGetData(tmpData);
						
						const tmpDataRef = response.data.data3;
						setGetDataRefLen(tmpDataRef.length);
						setGetData3(tmpDataRef);
					}
                }
            } catch (error) {
                console.error('실패:', error);
            } finally {
                setTimeout(() => {
                    pLoadingOff();
                },300);
            }
        };
        fetchData();
    }, []);


    const onRowSelect = (e) => {
        onEdit(e.value.idx);
    };


    const onRefRowSelect = (e) => {
        onEditRef(e.value.idx);
    };

	return (
		<>
		<LoadingComponent />
		<div className='components_wrap'>
			{getData2 === 1 && (
				<>
					<div className={styles.tab_btn_box}>
						<button
							className={[
								styles.tab_btn,
								activeTab === 'reco' && styles.active
								].filter(Boolean).join(' ')}
							onClick={() => setActiveTab('reco')}
						>예비추천서<span className={styles.sub_arrow}>추천권자 작성</span></button>

						{/* <button className={`${styles.tab_btn} ${styles.tab_btn_disable}`}>지원서<span className={styles.sub_arrow}>후보자 작성</span></button> */}
						
						<button
							className={[
								styles.tab_btn,
								activeTab === 'ref' && styles.active
								].filter(Boolean).join(' ')}
							onClick={() => setActiveTab('ref')}
						>추천서<span>추천권자 작성</span></button>
					</div>
					{activeTab === 'reco' && (
						<div>
							<div className={styles.code_wrap}>
								<div className='p_i_sec'>
									<div className='p_i'>
										<div className='p_i_con_box center'>
											{/* 20250804 26년에 등록하기 해제하자 */}
											{/* <button onClick={onRecommendation} className='p_btn p_btn_normal p_btn_blue '>등록하기</button> */}
										</div>
									</div>
								</div>
							</div>
							{getDataLen !== 0 && (
								<div className='naek_table table_mo_min_w_600'>
									<DataTable value={getData} selectionMode="single" onSelectionChange={onRowSelect} dataKey="idx">
										<Column field="idx" header="Num" bodyClassName="text-center" style={{ display: 'none' }}></Column>
										<Column field="createTime" header="등록일" bodyClassName="text-center"></Column>
										<Column field="status" header="상태" bodyClassName="text-center" style={{ display: 'none' }}></Column>
										<Column field="memberGradeName" header="회원구분" bodyClassName="text-center"></Column>
										<Column field="name" header="후보자" bodyClassName="text-center"></Column>
										<Column field="birth" header="생년" bodyClassName="text-center"></Column>
										<Column field="email" header="이메일"  bodyClassName="email_fontmask"
											body={(rowData) => (
												<span dangerouslySetInnerHTML={{ __html: rowData.email }} />
											)}></Column>
									</DataTable>
								</div>
							)}
						</div>
					)}
					
					{activeTab === 'ref' && (
						<div>
							{getDataRefLen !== 0 && (
								<div className='naek_table table_mo_min_w_600'>
									<DataTable value={getData3} selectionMode="single" onSelectionChange={onRefRowSelect} dataKey="idx">
										<Column field="idx" header="Num" bodyClassName="text-center" style={{ display: 'none' }}></Column>
										<Column field="createTime" header="등록일" bodyClassName="text-center"></Column>
										<Column field="status" header="상태" bodyClassName="text-center"></Column>
										<Column field="grade" header="회원구분" bodyClassName="text-center"></Column>
										<Column field="organization" header="현직" bodyClassName="text-center"></Column>
										<Column field="nameKR" header="후보자" bodyClassName="text-center"></Column>
										<Column field="email" header="이메일"  bodyClassName="email_fontmask"
											body={(rowData) => (
												<span dangerouslySetInnerHTML={{ __html: rowData.email }} />
											)}></Column>
									</DataTable>
								</div>
							)}
							{getDataRefLen === 0 && (
								<div className={`${styles.info_box2}`}>
									<li>내역이 없습니다.</li>
								</div>
							)}
						</div>
					)}
				</>
			)}
			{getData2 !== 1 && getData2 !== 0 && (
				<div className={`${styles.info_box2}`}>
					<li>회원에 대한 추천권한은 공학한림원 정회원과 단체회원 대표에게 있습니다.</li>
				</div>
			)}
		</div>
		</>
	);
}
































































function CodeInput({ onSubmitCode, openLoginModal }) {
	const { useAlert, useLoading } = common();
	const { pAlert, AlertComponent } = useAlert();
	const { pLoadingOn, pLoadingOff,LoadingComponent} = useLoading();

	const [code, setCode] = useState('');//입력하는 코오드

	const CodeSubmit = async () => {
		pAlert('관리자 확인 후, 지원서 작성 요청 이메일을 보내드리겠습니다.');
    };
	return (
		<>
		<AlertComponent />
		<LoadingComponent />
		<div className="top_tit_wrap "><span className="top_only_big_tit">회원 추천</span></div>
		<div className='components_wrap'>
			<div className={`${styles.info_box2}`}>
				<li>회원에 대한 추천권한은 공학한림원 정회원과 단체회원 대표에게 있습니다. 추천권자는 로그인 후 이용해주세요.</li>
			</div>
			<div className={`${styles.info_box2_bot}`}>
				<a onClick={openLoginModal} className='p_btn p_btn_normal'>로그인</a>
			</div>
		</div>
		</>
	);
}































































function App({isLogin,openLoginModal}) {
	const navigate = useNavigate();
    const location = useLocation();
	const [currentScreen, setCurrentScreen] = useState('');
	const [tempCode, setTempCode] = useState('');
	const [tempIdx, setTempIdx] = useState('');
	
	const [tempIdxRef, setTempIdxRef] = useState('');
	
	
	const totalMem=1;//정회원이 추천한 전체 인간들 명수 < 0이면 바로 등록하기 화면으로 갈려고
	const beforeMem=0;//정회원이 등록한 인간들 명수 < 추천순위때문에

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const view = query.get('view');
        const code = query.get('code');
        const idx = query.get('idx');
        const idxRef = query.get('idxref');
        
        setCurrentScreen(view || '');
        setTempCode(code || '');
        setTempIdx(idx || '');
        setTempIdxRef(idxRef || '');
    }, [location.search]);

	const moveRecommendation = () => {
		setCurrentScreen('recommendation');
		navigate('?view=recommendation');
	};
	
	const moveList = () => {
		setCurrentScreen('list');
		navigate('?view=list');
	};
	const moveListRef = () => {
		setCurrentScreen('listref');
		navigate('?view=listref');
	};


	
	const moveEdit = (idx) => {
		setTempIdx(idx);
		setCurrentScreen('edit');
		navigate('?view=edit');
	};
	const moveEditRef = (idx) => {
		setTempIdxRef(idx);
		setCurrentScreen('editref');
		navigate('?view=editref');
	};


	if(isLogin){
		if(currentScreen==='recommendation' || totalMem===0){
			return <CandidateDetail viewType='recommendation' onList={moveList} totalMem={totalMem} beforeMem={beforeMem} />;
		}
		
		if(currentScreen==='edit'){
			return <CandidateDetail viewType='edit' onList={moveList} totalMem={totalMem} beforeMem={beforeMem} isEditIdx={tempIdx} />;
		}
		
		if(currentScreen==='editref'){
			return <RefDetail onList={moveListRef} isEditIdx={tempIdxRef} />;
		}

		if(currentScreen==='list'){
			return <CandidateList onRecommendation={moveRecommendation} onEdit={moveEdit} onEditRef={moveEditRef} listType={currentScreen} />;
		}
		if(currentScreen==='listref'){
			return <CandidateList onRecommendation={moveRecommendation} onEdit={moveEdit} onEditRef={moveEditRef} listType={currentScreen} />;
		}
		return <CandidateList onRecommendation={moveRecommendation} onEdit={moveEdit} onEditRef={moveEditRef} listType={currentScreen} />;
	}


	// 2025 아래 return 2개는 비회원 화면과 안쓰는 화면임
	const moveCodeSubmit = (code) => {
		setTempCode(code);
		setCurrentScreen('nominee');
		navigate(`?view=nominee&code=${code}`);
	};
	if(currentScreen==='nominee'){
		console.log('1');
		return <CandidateDetail viewType='nominee' isCode={tempCode} />;
	}
	console.log('2');
	return <CodeInput onSubmitCode={moveCodeSubmit} openLoginModal={openLoginModal} />
}

export default App;